import Vue from 'vue';
import Router from 'vue-router';
import LandingLogin from '@/pages/LandingLogin';
import CreatePassword from '@/pages/CreatePassword';
import Dashboard from '@/pages/Dashboard';
import Widget from '@/components/Widgets';
import RecoveryPassword from '@/pages/RecoveryPassword';

Vue.use(Router);

export default new Router({
  routes: [
    {
      type: 'page',
      path: '/',
      name: 'LandingLogin',
      component: LandingLogin,
    },
    {
      type: 'page',
      path: '/createpassword',
      name: 'CreatePassword',
      component: CreatePassword,
    },
    {
      type: 'page',
      path: '/recoverypassword',
      name: 'RecoveryPassword',
      component: RecoveryPassword,
    },
    {
      type: 'page',
      path: '/recoverypassword/:token',
      name: 'RecoveryPassword',
      component: RecoveryPassword,
    },
    {
      type: 'page',
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
    },
    {
      nameWidget: 'home',
      nameFunction: 'home',
      name: 'home',
      path: '/home',
      direction: process.env.VUE_APP_WIDGET_HOME_URL,
      component: Widget,
    },
    {
      nameWidget: 'balance',
      nameFunction: 'balance',
      type: 'menu',
      name: 'Saldos',
      path: '/saldos',
      direction: process.env.VUE_APP_WIDGET_BALANCE_URL,
      component: Widget,
    },
    {
      nameWidget: 'details',
      nameFunction: 'widget',
      type: 'menu',
      name: 'Últimos movimientos',
      path: '/movimientos',
      direction: process.env.VUE_APP_WIDGET_DETAIL_URL,
      component: Widget,
    },
  ],
});
